module.exports = __webpack_public_path__ + "static/fonts/realiance-icons.05313b52.svg";